import { footerGroups } from '@/mocks/home';

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 pb-8 pt-14 text-background-200">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 md:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">黑料热点</span>
            </div>
            <p className="mt-4 text-xs leading-relaxed text-background-300">
              以人物为线索、以关系为路径，把黑料热点里的当事人、主角与关联人物集中整理成可翻阅的合集。
            </p>
          </div>

          {footerGroups.map((group) => (
            <div key={group.title}>
              <h4 className="font-label text-sm font-semibold text-background-50">{group.title}</h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a href={link.href} className="cursor-pointer text-xs text-background-300 transition-colors hover:text-background-50">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-primary-800 pt-6 sm:flex-row">
          <p className="text-xs text-background-400">© 2026 黑料热点 · 内容为专题合集整理，仅供浏览参考</p>
          <p className="text-xs text-background-400">人物档案 · 圈内关系 · 涉事方脉络</p>
        </div>
      </div>
    </footer>
  );
}